export default __webpack_public_path__ + "static/media/titolosandbox.fe9e02ac.png";